var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark mb-4"
    },
    [
      _c("a", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
        _vm._v(_vm._s(_vm.applicationName))
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse ml-4 ",
          attrs: { id: "navbarSupportedContent" }
        },
        [
          _c(
            "ul",
            {
              staticClass: "navbar-nav mr-auto",
              attrs: { id: "leftNavItems" }
            },
            _vm._l(_vm.leftNavData, function(navItem, index) {
              return _c(
                "li",
                {
                  key: "left-nav-item-" + parseInt(index),
                  class: [_vm.isDropdown(navItem) ? "dropdown" : "", "nav-item"]
                },
                [
                  !_vm.isDropdown(navItem)
                    ? [
                        _vm.isActiveItem(navItem) || navItem.name == "home"
                          ? [
                              _c(
                                "a",
                                {
                                  class: [
                                    _vm.isActiveItem(navItem) ? "active" : "",
                                    "nav-link"
                                  ],
                                  attrs: { href: navItem.url },
                                  on: {
                                    click: function($event) {
                                      return _vm.setActiveItem(navItem)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "fa" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fad", navItem.icon] }
                                      }),
                                      _vm._v(" "),
                                      _vm.hasNotifications(navItem)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "badge badge-warning"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  navItem.notifications.length
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(navItem.label) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ]
                    : [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link dropdown-toggle",
                            attrs: {
                              href: "#",
                              id: "navbarDropdown",
                              role: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fa" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fad", navItem.icon] }
                                })
                              ],
                              1
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(navItem.label) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { "aria-labelledby": "navbarDropdown" }
                          },
                          _vm._l(navItem.dropdownItems, function(
                            dropdownItem,
                            index
                          ) {
                            return _c(
                              "a",
                              {
                                key:
                                  "left-dropdown-nav-item-" + parseInt(index),
                                staticClass: "dropdown-item",
                                attrs: { href: dropdownItem.url }
                              },
                              [_vm._v(_vm._s(dropdownItem.name))]
                            )
                          }),
                          0
                        )
                      ]
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "navbar-nav", attrs: { id: "rightNavItems" } },
            [
              _c(
                "li",
                { ref: "vuedropdown", staticClass: "dropdown nav-item" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link dropdown-toggle",
                      attrs: {
                        href: "#",
                        id: "navbarDropdown",
                        role: "button",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "fa" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fad", "bell"] }
                          }),
                          _vm._v(" "),
                          _vm.amountNotifications > 0
                            ? _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_vm._v(_vm._s(_vm.amountNotifications))]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v("\n          Meldingen\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _vm.modules.length > 0
                    ? _c("notification-center", {
                        attrs: {
                          modules: _vm.modules,
                          update: _vm.notificationCenter.update
                        },
                        on: {
                          "notifications-changed": _vm.onNotificationsChanged
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.rightNavData, function(navItem, index) {
                return _c(
                  "li",
                  {
                    key: "right-nav-item-" + parseInt(index),
                    class: [
                      _vm.isDropdown(navItem) ? "dropdown" : "",
                      "nav-item"
                    ]
                  },
                  [
                    !_vm.isDropdown(navItem)
                      ? [
                          _c(
                            "a",
                            {
                              class: [
                                _vm.isActiveItem(navItem) ? "active" : "",
                                "nav-link"
                              ],
                              attrs: { href: navItem.url },
                              on: {
                                click: function($event) {
                                  return _vm.setActiveItem(navItem)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "fa" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", navItem.icon] }
                                  }),
                                  _vm._v(" "),
                                  _vm.hasNotifications(navItem)
                                    ? _c(
                                        "span",
                                        { staticClass: "badge badge-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(navItem.notifications.length)
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(navItem.label) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link dropdown-toggle",
                              attrs: {
                                href: "#",
                                id: "navbarDropdown",
                                role: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "fa" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", navItem.icon] }
                                  })
                                ],
                                1
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(navItem.label) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu",
                              attrs: { "aria-labelledby": "navbarDropdown" }
                            },
                            _vm._l(navItem.dropdownItems, function(
                              dropdownItem,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key:
                                    "right-dropdown-nav-item-" +
                                    parseInt(index),
                                  staticClass: "dropdown-item",
                                  attrs: { href: dropdownItem.url }
                                },
                                [_vm._v(_vm._s(dropdownItem.label))]
                              )
                            }),
                            0
                          )
                        ]
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c("li", { staticClass: "dropdown nav-item mr-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link dropdown-toggle",
                    attrs: {
                      href: "#",
                      id: "navbarDropdown",
                      role: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "fa" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fad", "user"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(
                      "\n          Aangemeld als " +
                        _vm._s(_vm.currentUser) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "navbarDropdown" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: _vm.baseURL + "logout" }
                      },
                      [
                        _vm._v("Afmelden\n            "),
                        _c("font-awesome-icon", {
                          staticClass: "ml-4",
                          attrs: { icon: ["fad", "sign-out"] }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }